import { ApolloProvider } from "@apollo/client"
import { graphqlApolloClient } from "../../services"

export function withApollo(Component) {
  return function (props) {
    return (
      <ApolloProvider client={graphqlApolloClient}>
        <Component {...props} client={graphqlApolloClient} />
      </ApolloProvider>
    )
  }
}
